import { BUSINESS_CHECKING_ACCOUNT } from 'axp-product-ducks';
import { getProcedureResult } from 'iguazu-rpc';
import {
  BUSINESS_SAVINGS_ACCOUNT,
  READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
  ROUTES,
} from '../constants';
import redirect from './redirect';

const isBcaProduct = (product) => product.type === BUSINESS_CHECKING_ACCOUNT;
const isBsaProduct = (product) => product.type === BUSINESS_SAVINGS_ACCOUNT;
const isSavingsUrl = (pathname) => pathname.includes('/savings/');

const redirectToProductHome = (store) => (nextState, replace) => {
  const state = store.getState();
  const productsResult = getProcedureResult({
    procedureName: READ_CUSTOMER_PRODUCTS_V2_FUNCTION,
    args: {
      timeout: 6e3,
    },
  })(state);

  const hasBca = productsResult.some(isBcaProduct);
  const hasBsa = productsResult.some(isBsaProduct);
  const enteredSavings = isSavingsUrl(nextState.location.pathname);

  if (hasBca && hasBsa) {
    redirect(enteredSavings ? ROUTES.BSA_HOME : ROUTES.BCA_HOME, replace);
    return;
  }

  if (hasBca) {
    redirect(ROUTES.BCA_HOME, replace);
    return;
  }

  if (hasBsa) {
    redirect(ROUTES.BSA_HOME, replace);
    return;
  }

  redirect(ROUTES.BCA_HOME, replace);
};

export default redirectToProductHome;
